import React from "react";
import ReactDOM from "react-dom";
import StoreWrapper from "App";
import reportWebVitals from "reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    <StoreWrapper />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
